<template>
    <div class="shipDetail">
        <div class="shipDetail-container">
            <ShipExperience 
                :productModel="shipExperience.experienceItems || []"
                :cruiseRoyalExperienceItems="categories"
                :itemViewModels="shipExperience.itemViewModel||[]"
                :ships="ships"
            />

            <div class="shipDetail-learnMore">
                <div class="shipDetail-learnMore-title">
                    <div class="shipDetail-learnMore-titleLine"></div>
                    <div class="shipDetail-learnMore-titleTxt">猜您还需要了解</div>
                </div>

                <RoyalExperienceShips 
                    :ships="ships"
                />

                <div class="shipDetail-pcp">
                    <div class="shipDetail-commonTitle">
                        <div class="shipDetail-commonTitleLine"></div>
                        <div class="shipDetail-commonTxt">皇家行前订</div>
                    </div>
                    <div class="shipDetail-pcpContainer">
                        <a :href="pcpUrl" class="external">
                            <img v-oss-img src="https://resource.rcclchina.com.cn/PCP/PROD/banner/Springdinning-banner-pc.jpg" alt="皇家行前订">
                            <span class="shipDetail-pcpTxt">皇家行前订</span>
                        </a>
                    </div>
                </div>

                <PromoCruise class="shipDetail-hotCruise"
                    :cruiseType="2"
                />
            </div>

        </div>
    </div>
</template>

<script>
const ShipExperience = () => import('@/components/Ship/ShipExperience')
const RoyalExperienceShips = () => import('@/components/Ship/RoyalExperienceShips')
const PromoCruise = () => import('@/components/Cruise/PromoCruise') 
export default {
    name: "ShipExperiencePage",
    components: {
        ShipExperience,
        PromoCruise,
        RoyalExperienceShips
    },
    asyncData ({ store }) {
        return new Promise((resolve, reject) => {
            return store.dispatch('GET_SHIP_EXPERIENCE')
            .then(()=> {
                resolve();
            })
            .catch((e)=> {
                reject(e)
            })
        })
    },
    beforeMount () {
        this.$store.commit('SET_PAGE_TITLE', '皇家游轮体验')
    },
    computed: {
        shipExperience () {
            return this.$store.state.page.shipExperience || {}
        },
        ships () {
            let ships = this.shipExperience.ships || []
            return ships.filter(r=>r.shipCode)
        },
        categories () {
            const categories = this.shipExperience.cruiseRoyalExperienceItemList || []
            // 超凡科技不显示
            return categories.filter(r=>r.category != '超凡科技')
        },
        pcpUrl () {
            return process.env.VUE_APP_PCP_URL
        }
    }
}
</script>

<style lang="less" scoped>
.shipDetail {
    padding-bottom: 88px;
    .shipDetail-container {
        background-color: #f2f2f2;
    }
    .shipDetail-learnMore {
        background-color: #f2f2f2;
        .shipDetail-learnMore-title {
            padding: 14px 0;
            position: relative;
            background-color: #f2f2f2;
            .shipDetail-learnMore-titleLine {
                height: 1px;
                background-color: #808080;
                margin-left: 17.2%;
                margin-right: 17.2%;
            }
            .shipDetail-learnMore-titleTxt {
                width: 100px;
                position: absolute;
                top: 6px;
                left: 50%;
                margin-left: -50px;
                padding: 0 1.867%;
                background-color: #f2f2f2;
                text-align: center;
                color: #808080;
                font-size: 11px;
            }
        }
        .shipDetail-hotCruise {
            margin-top: 9px;
        }

        .shipDetail-pcp {
            width: 100%;
            background-color: #fff;
            margin-top: 13px;
            padding: 0 3.2% 10px 3.2%;
            .shipDetail-commonTitle {
                padding: 27px 0;
                position: relative;
                .shipDetail-commonTitleLine {
                    height: 1px;
                    background-color: #fecc46;
                }
                .shipDetail-commonTxt {
                    width: 80px;
                    position: absolute;
                    top: 18px;
                    left: 50%;
                    margin-left: -40px;
                    padding: 0 1.867%;
                    background-color: #fff;
                    text-align: center;
                    color: #061556;
                    font-size: 13px;
                }
            }
            img {
                width: 100%;
                display: block;
            }
            .shipDetail-pcpTxt {
                background-color: #febd11;
                width: 100%;
                height: 35px;
                text-align: center;
                line-height: 35px;
                color: #fff;
                font-size: 13px;
                display: inline-block;
            }
        }
    }
}
</style>